import { brandStats, heroMinis } from '@/mocks/homeData';

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden">
      {/* 光面氛围底 */}
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute -left-24 top-10 h-72 w-72 rounded-full bg-primary-100/70 blur-3xl" />
        <div className="absolute -right-16 bottom-4 h-80 w-80 rounded-full bg-accent-100/60 blur-3xl" />
      </div>

      <div className="relative mx-auto grid max-w-7xl gap-10 px-4 py-12 md:px-6 md:py-16 lg:grid-cols-[1.25fr_0.9fr] lg:gap-14">
        {/* 文案优先 */}
        <div className="flex flex-col justify-center">
          <p className="inline-flex w-fit items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-4 py-1.5 text-sm text-primary-700">
            <span className="relative flex h-2 w-2">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-accent-500 opacity-75" />
              <span className="relative inline-flex h-2 w-2 rounded-full bg-accent-600" />
            </span>
            51黑料 · 话题热榜每日滚动更新
          </p>

          <h1 className="mt-6 font-heading text-4xl font-black leading-[1.15] tracking-tight text-foreground-950 md:text-5xl lg:text-[3.4rem]">
            今天，大家在聊的
            <br />
            都在<a href="#hot" className="text-primary-600 underline decoration-accent-400 decoration-4 underline-offset-8">黑料榜</a>上
          </h1>

          <p className="mt-6 max-w-xl text-base leading-relaxed text-foreground-600 md:text-lg">
            从最新合集到往期汇总，按热度排序为你滚动盘点。职场、直播、品牌、饭圈——当前讨论度最高的黑料话题，一条都不漏。
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="#hot"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-lg bg-primary-500 px-6 py-3.5 text-sm font-medium text-background-50 transition hover:bg-primary-600"
            >
              围观今日热榜
              <i className="ri-arrow-right-down-line text-base" />
            </a>
            <a
              href="#collections"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-lg border border-background-300 bg-background-50 px-6 py-3.5 text-sm font-medium text-foreground-800 transition hover:border-primary-300 hover:text-primary-700"
            >
              <i className="ri-stack-fill text-base text-accent-600" />
              翻话题合集
            </a>
          </div>

          {/* 数据条 */}
          <dl className="mt-10 flex flex-wrap gap-x-10 gap-y-4 border-t border-background-200 pt-6">
            {brandStats.map((s) => (
              <div key={s.label}>
                <dt className="order-2 text-xs text-foreground-500">{s.label}</dt>
                <dd className="font-heading text-2xl font-bold text-foreground-950">{s.value}</dd>
              </div>
            ))}
          </dl>
        </div>

        {/* 视觉陪衬：即时迷你榜 */}
        <div className="relative lg:pt-2">
          <div className="rounded-2xl border border-background-200 bg-background-50/70 p-5 shadow-[0_1px_0_0_oklch(var(--background-200))] md:p-6">
            <div className="flex items-center justify-between">
              <h2 className="font-heading text-lg font-bold text-foreground-950">
                <i className="ri-flashlight-fill mr-1.5 text-accent-600" />
                此刻 · 实时热议
              </h2>
              <span className="rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-800">
                LIVE 刷新中
              </span>
            </div>

            <div className="mt-4 divide-y divide-background-200">
              {heroMinis.map((m, i) => (
                <a
                  href="#community"
                  key={m.title}
                  className="group flex items-center gap-4 py-3.5 transition"
                >
                  <span className="font-heading text-xl font-black text-primary-300 transition group-hover:text-primary-500">
                    {String(i + 1).padStart(2, '0')}
                  </span>
                  <div className="min-w-0 flex-1">
                    <p className="truncate text-sm font-medium text-foreground-900 transition group-hover:text-primary-700">
                      {m.title}
                    </p>
                    <p className="mt-0.5 text-xs text-foreground-500">#{m.tag}</p>
                  </div>
                  <span className="flex shrink-0 items-center gap-1 whitespace-nowrap rounded-full bg-secondary-100 px-2.5 py-1 text-xs font-medium text-secondary-800">
                    <i className="ri-fire-fill text-accent-600" />
                    {m.heat}
                  </span>
                </a>
              ))}
            </div>

            <a
              href="#hot"
              className="mt-2 flex items-center justify-center gap-1 rounded-lg bg-secondary-100 py-2.5 text-sm font-medium text-secondary-900 transition hover:bg-primary-100 hover:text-primary-700"
            >
              查看完整榜单一页
              <i className="ri-arrow-right-s-line text-lg" />
            </a>
          </div>

          {/* 浮动角标 */}
          <div className="absolute -bottom-5 -left-3 hidden rotate-[-4deg] rounded-lg bg-primary-950 px-4 py-2 font-heading text-sm font-bold text-accent-400 lg:block">
            每周三出深度盘点
          </div>
        </div>
      </div>
    </section>
  );
}